export default "__VITE_ASSET__CrxrES8P__"